import {isAlphaProfile, isBetaProfile, isDevProfile, isLocalProfile, isRealProfile} from '@web/core/config'
import {PageSet} from '@web/core/constants'

const getEnvName = (): 'dev' | 'alpha' | 'beta' | 'real' => {
    if (isLocalProfile || isDevProfile) {
        return 'dev'
    }
    if (isAlphaProfile) {
        return 'alpha'
    }
    if (isBetaProfile) {
        return 'beta'
    }
    if (isRealProfile) {
        return 'real'
    }
    return 'alpha'
}

export const envName = getEnvName()

const MASSRONOME_BASE_URL: Record<'dev' | 'alpha' | 'beta' | 'real', string> = {
    dev: 'https://dev-massronome-v2-sse.fin.navercorp.com',
    alpha: 'https://alpha-massronome-v2-sse.fin.navercorp.com',
    beta: 'https://beta-massronome-v2-sse.fin.navercorp.com',
    real: 'https://massronome-v2-sse.fin.navercorp.com',
}

export const getMassronomeServerUrl = (): string => {
    return MASSRONOME_BASE_URL[envName]
}

export const getMassronomeSseUrl = (): string => {
    return `${getMassronomeServerUrl()}/sse`
}

export const getPageName = (pageSet: Maybe<Constant<typeof PageSet>>): string => {
    switch (pageSet) {
        case PageSet.MALL_CHECKOUT:
            return 'mall'
        case PageSet.EASY_BOOK_CHECKOUT:
            return 'easybooking'
        case PageSet.SELLER_CHECKOUT:
            return 'seller'
        default:
            return 'seller'
    }
}

export const getPathName = (pageSet: Maybe<Constant<typeof PageSet>>): string => {
    switch (pageSet) {
        case PageSet.MALL_CHECKOUT:
            return 'orderSheet/mall'
        case PageSet.EASY_BOOK_CHECKOUT:
            return 'orderSheet/easyBooking'
        case PageSet.SELLER_CHECKOUT:
            return 'orderSheet/seller'
        default:
            return 'orderSheet/seller'
    }
}
